import { fallbackImage } from "components/Movie/utils";
import { Typography, Button } from "neetoui";
import { useTranslation } from "react-i18next";
import { useHistoryStore } from "stores/useHistoryStore";
import { camelCaseToTitleCase } from "utils/camelCaseToTitleCase";

const Card = ({ title, year, poster, onViewDetails, type }) => {
  const { t } = useTranslation();
  const addToHistory = useHistoryStore.pickFrom();
  const handleClick = () => {
    addToHistory(title, scrolledTitle => {
      const element = document.getElementById(`history-${scrolledTitle}`);
      element?.scrollIntoView({ behavior: "smooth", block: "center" });
    });
    onViewDetails?.();
  };

  return (
    <div className="m-4 mx-auto flex w-full max-w-xs flex-col justify-between rounded-2xl bg-white p-4 shadow-md transition hover:shadow-xl">
      <div>
        <img
          alt={t("imageAlt.moviePoster")}
          className="m-auto h-72 w-full rounded-xl object-cover"
          src={poster}
          onError={fallbackImage}
        />
      </div>
      <div className="mt-4 space-y-1 text-left">
        <Typography className="text-xl" style="h3" weight="bold">
          {title}
        </Typography>
        <Typography className="text-gray-500">
          {camelCaseToTitleCase(type)} · {year}
        </Typography>
        <div className="mt-auto pt-4">
          <Button
            className="w-full justify-center bg-gray-300 text-blue-600 focus:text-blue-800"
            onClick={handleClick}
          >
            {t("buttons.viewDetails")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Card;
